import React from 'react';
import PaymentContent from '../PaymentContent';
import withPayment from '../withPayment';

class InPagePayment extends React.Component {
  render() {
    return (
      <div className="common-page-content document-page-container">
        <PaymentContent {...this.props} />
      </div>
    );
  }
}

export default withPayment(InPagePayment);
